import { cn } from "@/lib/utils";

export interface ULThemeSeparatorProps {
  /**
   * Optional text to display in the middle of the separator
   */
  text?: string;
  /**
   * Optional class names for additional styling or overriding default styles
   */
  className?: string;
}

const ULThemeSeparator = ({ text, className }: ULThemeSeparatorProps) => {
  // Base styles
  const containerStyles = "relative flex items-center justify-center my-4";

  // Theme overrides for text
  const themedTextStyles = cn(
    "flex-shrink px-3 py-1 rounded-full bg-white/50 backdrop-blur-sm",
    "theme-universal:text-[#242424]",
    "theme-universal:text-(length:--ul-theme-font-body-text-size)",
    "theme-universal:font-body tracking-[0.12em] uppercase"
  );

  if (text) {
    return (
      <div className={cn(containerStyles, className)}>
        <span className={themedTextStyles}>{text}</span>
      </div>
    );
  }

  return null;
};

export default ULThemeSeparator;
